import Cookies from 'js-cookie';

export const reportConfig = {
  'vendor kpi report': {
    selectValues: '*',
    title: 'Vendor KPI Report',
    db: 'SF',
    tableName: 'REPORT.VENDOR_KPI_REPORT_DETAIL',
    whereField: ['CLIENT_NAME'],
    whereOperators: ['='],
    orderBy: 'EDI_INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn')?.toUpperCase()],
  },
  'address correction' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Address Correction Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Address Corrections'],
  },
  'additional handling' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Additional Handling Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Additional Handling - Large Package - Overmax'],
  },
  'ltl-tl additional handling' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL, ACCOUNT_NUMBER)',
    title: 'LTL-TL Additional Handling Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS_TL_LTL_VW',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Additional Handling - Large Package - Overmax'],
  },
  'chargebacks' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Chargebacks Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Chargebacks'],
  },
  'guaranteed services' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Guaranteed Services Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'GSR Guarantee Service Refunds'],
  },
  'ltl-tl guaranteed services' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL, ACCOUNT_NUMBER)',
    title: 'LTL-TL Guaranteed Services Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS_TL_LTL_VW',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'GSR Guarantee Service Refunds'],
  },
  'intercept' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Intercept Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Intercept'],
  },
  'invalid account fees' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Invalid Account Fees Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Invalid Account Fees'],
  },
  'ltl-tl invalid account fees' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL, ACCOUNT_NUMBER)',
    title: 'LTL-TL Invalid Account Fees Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS_TL_LTL_VW',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Invalid Account Fees'],
  },
  'late payment fees details' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Late Payment Fees Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Late Payment Fees'],
  },
  'missing pld fees' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Missing PLD Fees Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Missing PLD Fees'],
  },
  'peak demand surcharges' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Peak Demand Surcharges Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Peak Demand Surcharges'],
  },
  'undeliverable return' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Undeliverable Return Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Undeliverable Return'],
  },
  'returns' : {
    selectValues: '* EXCLUDE(CUSTOMER, LABEL)',
    title: 'Returns Report',
    db: 'SF',
    tableName: 'REPORT.COST_TRENDS_DETAILS',
    whereField: ['CUSTOMER', 'LABEL'],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn'), 'Returns'],
  },
  'multi stop hottest regions': {
    selectValues: '*',
    title: 'Hottest Multi-Stop Regions',
    db: 'SQL SERVER',
    tableName: 'reports.MULTI_STOP_REGION_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'NUMBER_OF_SHIPMENTS DESC',
    getWhereValue: () => [Cookies.get('cp-cn')],  
  },
  'multi-stop trends': {
    selectValues: '*',
    title: 'Multi-Stop Trends',
    db: 'SQL SERVER',
    tableName: 'reports.MULTI_STOP_TRENDS',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'TIMES_RAN_IN_LAST_6_MONTHS DESC',
    getWhereValue: () => [Cookies.get('cp-cn')],  
  },
  'parcel charge description': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Parcel Charge Descriptions',
    db: 'SF',
    tableName: 'REPORT.CHARGE_DESCRIPTIONS_SUMMARY_VW ',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: '"CHARGE_DESCRIPTION"',
    getWhereValue: () => [Cookies.get('cp-cn')],  
  },
    'ltl-tl charge description': {
    selectValues: '*',
    title: 'LTL-TL Charge Descriptions',
    db: 'SF',
    tableName: 'REPORT.FTL_LTL_CHARGE_DESCRIPTIONS_VW ',
    whereField: ['Customer'],
    whereOperators: ['='],
    orderBy: '"Customer", "Carrier", "Volume" DESC',
    getWhereValue: () => [Cookies.get('cp-cn')],  
  },
  'audit net rate': {
    selectValues: "TOP 1 CASE WHEN ERROR_STATUS != 'NO NRS' THEN 1 ELSE 2 END AS ERROR_STATUS, YEAR, WEEK",
    title: 'Audit Net Rate',
    db: 'SF',
    tableName: 'REPORT.ALL_COMBINED_AUDIT_52_WEEKS_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'YEAR DESC, CAST(WEEK AS INT) DESC',
    getWhereValue: () => [Cookies.get('cp-cn')],  
  },
  'audit summary': {
    selectValues: "ROUND((SUM(CONTRACT_AMOUNT) / SUM(CHARGE_AMOUNT)) * 100, 2) AS CORRECT_AUDIT_PERCENT, ROUND(100 - ((SUM(CONTRACT_AMOUNT) / SUM(CHARGE_AMOUNT)) * 100), 2) AS INCORRECT_AUDIT_PERCENT, TO_CHAR(SUM(CHARGE_AMOUNT), '$999,999,999,999.00') AS CHARGE_AMOUNT, TO_CHAR(SUM(CONTRACT_AMOUNT), '$999,999,999,999.00') AS CONTRACT_AMOUNT, TO_CHAR(SUM(OVERBILLED), '$999,999,999,999.00') AS OVERBILLED",
    title: 'Audit Summary',
    db: 'SF',
    tableName: 'REPORT.ALL_COMBINED_AUDIT_52_WEEKS_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'CHARGE_AMOUNT',
    getWhereValue: () => [Cookies.get('cp-cn')],  
  },
  'audit download': {
    selectValues: "*",
    title: 'Audit Summary',
    db: 'SF',
    tableName: 'REPORT.PARCEL_AUDIT_DOWNLOAD',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'CUSTOMER',
    getWhereValue: () => [Cookies.get('cp-cn')],  
  },
  'carrier scorecard': {
    selectValues: "*",
    title: 'Carrier ScoreCard',
    db: 'SQL SERVER',
    tableName: 'reports.CARRIER_SCORECARD',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'TOTAL_LOADS DESC',
    getWhereValue: () => [Cookies.get('cp-cn')], 
  },
  'carrier scorecard totals': {
    selectValues: "*",
    title: 'Carrier ScoreCard Totals',
    db: 'SQL SERVER',
    tableName: 'REPORTS.CARRIER_SCORECARD_TOTALS',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'CUSTOMER DESC',
    getWhereValue: () => [Cookies.get('cp-cn')], 
  },
  '3pl level report': {
    selectValues: '* EXCLUDE (PARENT_COMPANY)',
    title: '3PL Level Report',
    db: 'SF',
    tableName: 'REPORT.MASTER_3PL_REPORT_VW',
    whereField: ['PARENT_COMPANY'],
    whereOperators: ['='],
    orderBy: 'SHIP_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn')],
  }, 
  '3pl customer report': {
    selectValues: '* EXCLUDE(PARENT_COMPANY, MARKUP, OUR_SHIPPING_COST)',
    title: '3PL Customer Report',
    db: 'SF',
    tableName: 'REPORT.MASTER_3PL_REPORT_VW',
    whereField: ['CUSTOMER_NAME'],
    whereOperators: ['='],
    orderBy: 'SHIP_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'fulfillment team report' : {
    selectValues: `SHIPMENT_ID, SHIPMENT_PARCEL_ID, SHIP_DATE, ORDER_ID, ORDER_NUMBER,
    TRACKING_NUMBER, WEIGHT, LENGTH, WIDTH, HEIGHT, ZONE,
    SHIP_TO_FIRST_NAME, SHIP_TO_LAST_NAME, SHIP_TO_COMPANY,
    SHIP_TO_ADDRESS_1, SHIP_TO_ADDRESS_2, SHIP_TO_CITY, SHIP_TO_STATE,
    SHIP_TO_ZIP, SHIP_TO_COUNTRY, WAREHOUSE_NAME, VOIDED, CARRIER,
    SERVICE, SHIPPING_SERVICE_LEVEL, CUSTOMER_NAME,
    SHIPMENT_UNIQUE_UNITS_SHIPPED, SHIPMENT_TOTAL_UNITS_SHIPPED,
    PARCEL_UNIQUE_UNITS_SHIPPED, PARCEL_TOTAL_UNITS_SHIPPED,
    MARKUP, CUSTOMER_SHIPPING_COST, OUR_SHIPPING_COST`
  },
  'fulfillment team report coc': {
    selectValues: `
    SHIPMENT_ID, SHIPMENT_PARCEL_ID, SHIP_DATE, ORDER_ID, ORDER_NUMBER,
    TRACKING_NUMBER, WEIGHT, LENGTH, WIDTH, HEIGHT,
    SHIP_TO_FIRST_NAME, SHIP_TO_LAST_NAME, SHIP_TO_COMPANY,
    SHIP_TO_ADDRESS_1, SHIP_TO_ADDRESS_2, SHIP_TO_CITY, SHIP_TO_STATE,
    SHIP_TO_ZIP, SHIP_TO_COUNTRY, WAREHOUSE_NAME, VOIDED, CARRIER,
    SERVICE, SHIPPING_SERVICE_LEVEL,
    SHIPMENT_UNIQUE_UNITS_SHIPPED, SHIPMENT_TOTAL_UNITS_SHIPPED,
    PARCEL_UNIQUE_UNITS_SHIPPED, PARCEL_TOTAL_UNITS_SHIPPED,
    CUSTOMER_SHIPPING_COST`
  },
  'flexhubAdmin': {
    selectValues: `
    TRACKINGNUMBER as TRACKING_NUMBER, CAST(SHIPDATE  AS DATE) as SHIP_DATE, CARRIER as CARRIER,
    CUSTOMERNAME as CUSTOMER_NAME, TRACKINGSTATUS as TRACKING_STATUS,
    CAST(LASTTRACKED AS DATE) as LAST_TRACKED, TRACKINGDESCRIPTION as TRACKING_DESCRIPTION, CASE WHEN VOIDEDDATE = 'N/A' THEN NULL ELSE CAST(VOIDEDDATE AS DATE) END AS VOIDED_DATE,
    DESTINATIONCOMPANYNAME as DESTINATION_COMPANY, DESTINATIONCITY as DESTINATION_CITY,
    DESTINATIONSTATE as DESTINATION_STATE, DESTINATIONPOSTALCODE as DESTINATION_POSTAL, COST`
  },
  'flexhubCOC': {
    selectValues: `
    TRACKINGNUMBER as TRACKING_NUMBER, CAST(SHIPDATE  AS DATE) as SHIP_DATE, CARRIER as CARRIER,
    //CASE WHEN VOIDEDDATE = 'N/A' THEN NULL ELSE CAST(VOIDEDDATE AS DATE) END AS VOIDED_DATE,
    DESTINATIONCOMPANYNAME as DESTINATION_COMPANY, DESTINATIONCITY as DESTINATION_CITY,
    DESTINATIONSTATE as DESTINATION_STATE, DESTINATIONPOSTALCODE as DESTINATION_POSTAL,
    TRACKINGDESCRIPTION as TRACKING_DESCRIPTION`
  },
  'remitIngestion': {
    selectValues: `
    "REMIT_DATE", "CARRIERSHORTNM" AS CARRIER_NAME, "BOL" as BOL, "INVNBR" as INVOICE_NUMBER, "INVOICEDATE" as INVOICE_DATE, "NETCHARGES" as NET_CHARGES, "GL_CODE", 
    "SHIPDATE" as SHIP_DATE, "DELIVERYDATE" as DELIVER_DATE, "SHIPFROMCOMPANYNM" as SHIP_FROM, "SHIPFROMSTREETADDR1" as SHIP_FROM_ADDRESS, "SHIPFROMCITY" as SHIP_FROM_CITY, 
    "SHIPFROMSTATE" as SHIP_FROM_STATE, "SHIPFROMZIP" as SHIP_FROM_ZIP, "SHIPFROMCOUNTRY" as SHIP_FROM_COUNTRY, "SHIPTOCUSTOMERNM" as SHIP_TO, "SHIPTOSTREETADDR1" as SHIP_TO_ADDRESS, 
    "SHIPTOCITY" as SHIP_TO_CITY, "SHIPTOSTATE" as SHIP_TO_STATE, "SHIPTOZIP" as SHIP_TO_ZIP, "SHIPTOCOUNTRY" as SHIP_TO_COUNTRY, "PONBR" as PO_NUMBER, "WEIGHT", "LENGTH", "WIDTH", 
    "HEIGHT", "CLASS", "FREIGHT", "DISCOUNT", "FUEL", "LIFTGATE", "LIMITED_ACCESS", "NOTIFY", 
    "REWEIGH/RECLASS", "STATE_SURCHARGE", "DELIVERY", "OVERLENGTH", "PICKUP", "SINGLE_SHIPMENT", "MISCELLANEOUS", 
    "OTHER"`
  },
  'shipping volume': {
    selectValues: "*",
    title: 'Shipping Volume',
    db: 'SF',
    tableName: 'REPORT.SHIPPING_VOLUME',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'CUSTOMER',
    getWhereValue: () => [Cookies.get('cp-cn')], 
  },
  'ups parcel credits': {
    selectValues: "*",
    title: 'UPS Parcel Credits',
    db: 'SF',
    tableName: 'REPORT.PARCEL_CREDIT_UPS_SAVINGS',
    whereField: ['COMPANY_NAME'],
    whereOperators: ['='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn')], 
  },
  'fedex parcel credits': {
    selectValues: "*",
    title: 'FedEx Parcel Credits',
    db: 'SF',
    tableName: 'REPORT.PARCEL_CREDIT_FEDEX_SAVINGS',
    whereField: ['COMPANY_NAME'],
    whereOperators: ['='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn')], 
  },
  'account overview': {
    selectValues: "* EXCLUDE(CUSTOMER)",
    title: 'Account Overview',
    db: 'SF',
    tableName: 'REPORT.ACCOUNT_OVERVIEW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'ACCOUNT_DESCRIPTION ASC',
    getWhereValue: () => [Cookies.get('cp-cn')], 
  },
  'account overview chart': {
    selectValues: "* EXCLUDE(CUSTOMER)",
    title: 'Account Overview Chart',
    db: 'SF',
    tableName: 'REPORT.ACCOUNT_OVERVIEW_CHART',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'WEEK_START',
    getWhereValue: () => [Cookies.get('cp-cn')], 
  },
  'ltl statistics': {
    selectValues: "CARRIER_NAME, PERCENT_OF_TOTAL_VOLUME, NUMBER_OF_SHIPMENTS, CHARGE_AMOUNT, AVERAGE_CHARGE, WEIGHT, AVERAGE_BILLED_WEIGHT",
    title: 'LTL Statistics',
    db: 'SQL SERVER',
    tableName: 'REPORTS.LTL_STATISTICS_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'CARRIER_NAME ASC',
    getWhereValue: () => [Cookies.get('cp-cn')], 
  },
  'unexpected charges': {
    selectValues: "* EXCLUDE(CUSTOMER)",
    title: 'Unexpected Charges',
    db: 'SF',
    tableName: 'REPORT.UNEXPECTED_CHARGES_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'VOLUME DESC',
    getWhereValue: () => [Cookies.get('cp-cn')?.toUpperCase()], 
    getDownloadData: 'unexpected charges download'
  },
  'unexpected charges download': {
    selectValues: "*",
    title: 'Unexpected Charges Download',
    db: 'SF',
    tableName: 'REPORT.UNEXPECTED_CHARGES_DETAILS_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'CARRIER_NAME DESC',
    getWhereValue: () => [Cookies.get('cp-cn')?.toUpperCase()], 
  },
  'duplicate billing': {
    selectValues: '*',
    title: 'Duplicate Billing Chart',
    db: 'SF',
    tableName: 'REPORT.VW_DUPLICATE_BILLING',
    whereField: ['Customer', 'CHARGE_AMOUNT'],
    whereOperators: ['=', '!='],
    orderBy: 'WEEK_OF_INVOICE_DATE desc',
    getWhereValue: () => [Cookies.get('cp-cn'), 0],
  },
  'total charges for duplicate billing': {
    selectValues: '*',
    title: 'Duplicate Billing Chart',
    db: 'SF',
    tableName: 'REPORT.VW_DUPLICATE_BILLING',
    whereField: ['Customer', 'CHARGE_AMOUNT'],
    whereOperators: ['=', '!='],
    orderBy: 'WEEK_OF_INVOICE_DATE desc',
    getWhereValue: () => [Cookies.get('cp-cn'), 0],
  },
    'duplicate billing volume': {
    selectValues: '*',
    title: 'Duplicate Billing Chart',
    db: 'SF',
    tableName: 'REPORT.VW_DUPLICATE_BILLING',
    whereField: ['Customer', 'CHARGE_AMOUNT'],
    whereOperators: ['=', '!='],
    orderBy: 'WEEK_OF_INVOICE_DATE desc',
    getWhereValue: () => [Cookies.get('cp-cn'), 0],
  },
  'late payment fees': {
    selectValues: '*',
    title: 'Late Payment Fees',
    db: 'SF',
    tableName: 'REPORT.VW_LATE_PAYMENT_FEES',
    whereField: ['Customer', 'ChargeAmount'],
    whereOperators: ['=', '>'],
    orderBy: '"InvoiceDate"',
    getWhereValue: () => [Cookies.get('cp-cn'), 0],
  },
    'total charges for late payment fees': {
    selectValues: '*',
    title: 'Late Payment Fees',
    db: 'SF',
    tableName: 'REPORT.VW_LATE_PAYMENT_FEES',
    whereField: ['Customer', 'ChargeAmount'],
    whereOperators: ['=', '>'],
    orderBy: '"InvoiceDate"',
    getWhereValue: () => [Cookies.get('cp-cn'), 0],
  },
    'total count of invoices with late payment fees': {
    selectValues: '*',
    title: 'Late Payment Fees',
    db: 'SF',
    tableName: 'REPORT.VW_LATE_PAYMENT_FEES',
    whereField: ['Customer', 'ChargeAmount'],
    whereOperators: ['=', '>'],
    orderBy: '"InvoiceDate"',
    getWhereValue: () => [Cookies.get('cp-cn'), 0],
  },
  'average week spend': {
    selectValues: '*',
    title: 'Cost Analysis',
    db: 'SF',
    tableName: 'REPORT.COST_ANALYSIS_WEEKLY_CHARGE_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: '"CUSTOMER"',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'cost analysis': {
    selectValues: '*',
    title: 'Cost Analysis',
    db: 'SF',
    tableName: 'REPORT.COST_ANALYSIS_WEEKLY_CHARGE_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: '"CUSTOMER"',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'cost analysis weekly': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Cost Analysis',
    db: 'SF',
    tableName: 'REPORT.COST_ANALYSIS_WEEKLY_CHART_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: '"WEEK"',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'cost analysis carrier': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Cost Analysis Carrier',
    db: 'SF',
    tableName: 'REPORT.COST_ANALYSIS_CARRIER_CHART_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: '"CARRIER"',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'accounts by carrier': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Accounts By Carrier',
    db: 'SF',
    tableName: 'REPORT.ACCOUNT_BY_CARRIER_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: '"CARRIER"',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'global distribution': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Global Distribution',
    db: 'SF',
    tableName: 'REPORT.GLOBAL_DISTRIBUTION_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: '"ORIGIN_COUNTRY"',
    getWhereValue: () => [Cookies.get('cp-cn')],
    getDownloadData: 'global distribution download'
  },
    'global distribution download': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Global Distribution',
    db: 'SF',
    tableName: 'REPORT.GLOBAL_DISTRIBUTION_DOWNLOAD_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: '"ORIGIN_COUNTRY"',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'zone summary': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Zone Summary',
    db: 'SF',
    tableName: 'REPORT.ZONE_SUMMARY_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'ZONE DESC',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'inactive accounts': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Inactive Accounts',
    db: 'SF',
    tableName: 'REPORT.INACTIVE_ACCOUNTS_CHART_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'INVOICE_WEEK ASC',
    getWhereValue: () => [Cookies.get('cp-cn')],
    getDownloadData: 'inactive account download'
  },
  'inactive account download': {
    selectValues: '*',
    title: 'Inactive Accounts',
    db: 'SF',
    tableName: 'REPORT.INACTIVE_ACCOUNTS_DOWNLOAD_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'CUSTOMER ASC',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'top charges by account number': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Inactive Accounts',
    db: 'SF',
    tableName: 'REPORT.INACTIVE_ACCOUNTS_TOP_CHARGES_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'TOTAL DESC',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'number of invoices with inactive charges': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Inactive Accounts',
    db: 'SF',
    tableName: 'REPORT.INACTIVE_ACCOUNTS_COUNT_INVOICES_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'VALUE ASC',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'total charges for inactive account': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Inactive Accounts',
    db: 'SF',
    tableName: 'REPORT.INACTIVE_ACCOUNTS_TOTAL_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'VALUE ASC',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'ic sales report': {
    selectValues: '*',
    title: 'ShipWise Sales',
    db: 'SF',
    tableName: 'REPORT.SALESWISE_SALES_VW',
    whereField: ['EMPLOYEE'],
    whereOperators: ['='],
    orderBy: 'SHIP_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-un')],
  },
  'total by invoice number': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Inactive Accounts',
    db: 'SF',
    tableName: 'REPORT.PARCEL_INVOICES_TOTAL_INVOICE_NUMBER_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: () => [Cookies.get('cp-cn')],
    //whereValue: [Cookies.get('cp-cn')],
  },
  'total by service': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Inactive Accounts',
    db: 'SF',
    tableName: 'REPORT.PARCEL_INVOICES_TOTAL_SERVICE_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'SERVICE_DESCRIPTION ASC',
    getWhereValue: () => [Cookies.get('cp-cn')],
    //whereValue: [Cookies.get('cp-cn')],
  },
  'total by charge description': {
    selectValues: '* EXCLUDE(CUSTOMER)',
    title: 'Inactive Accounts',
    db: 'SF',
    tableName: 'REPORT.PARCEL_INVOICES_CHARGE_DESC_VW',
    whereField: ['CUSTOMER'],
    whereOperators: ['='],
    orderBy: 'CHARGE_DESCRIPTION ASC',
    getWhereValue: () => [Cookies.get('cp-cn')],
    //whereValue: [Cookies.get('cp-cn')],
  }, 
  'service stats': {
    selectValues: '* EXCLUDE("Customer")',
    title: 'Service Statistics',
    db: 'SF',
    tableName: 'REPORT.FORMATTED_SERVICE_STATS_VW',
    whereField: ["Customer"],
    whereOperators: ['='],
    orderBy: '"Carrier" DESC, "Charge Amount" DESC',
    getWhereValue: () => [Cookies.get('cp-cn')],
  },
  'ups rfp': {
    selectValues: '* EXCLUDE(CUSTOMER, CARRIER)',
    title: 'UPS RFP',
    db: 'SF',
    tableName: 'REPORT.RFP_BILLING_VW',
    whereField: ["CUSTOMER", "CARRIER"],
    whereOperators: ['=', '='],
    orderBy: "CASE WHEN SERVICE_DESCRIPTION = 'TOTAL' THEN 1 ELSE 0 END, SERVICE_DESCRIPTION",
    getWhereValue: () => [Cookies.get('cp-cn'), 'UPS'],
  },
  'fedex rfp': {
    selectValues: '* EXCLUDE(CUSTOMER, CARRIER)',
    title: 'FedEx RFP',
    db: 'SF',
    tableName: 'REPORT.RFP_BILLING_VW',
    whereField: ["CUSTOMER", "CARRIER"],
    whereOperators: ['=', '='],
    orderBy: "CASE WHEN SERVICE_DESCRIPTION = 'TOTAL' THEN 1 ELSE 0 END, SERVICE_DESCRIPTION",
    getWhereValue: () => [Cookies.get('cp-cn'), 'FedEx'],
  },
  'dhl rfp': {
    selectValues: '* EXCLUDE(CUSTOMER, CARRIER)',
    title: 'DHL RFP',
    db: 'SF',
    tableName: 'REPORT.RFP_BILLING_VW',
    whereField: ["CUSTOMER", "CARRIER"],
    whereOperators: ['=', '='],
    orderBy: "CASE WHEN SERVICE_DESCRIPTION = 'TOTAL' THEN 1 ELSE 0 END, SERVICE_DESCRIPTION",
    getWhereValue: () => [Cookies.get('cp-cn'), 'DHL'],
  },
  'rfp area chart': {
    selectValues: '* EXCLUDE(CUSTOMER, CARRIER)',
    title: 'Area RFP',
    db: 'SF',
    tableName: 'REPORT.RFP_BILLING_CHART_VW ',
    whereField: ["CUSTOMER", "CARRIER"],
    whereOperators: ['=', '='],
    orderBy: 'INVOICE_DATE DESC',
    getWhereValue: (params) => [Cookies.get('cp-cn'), params.carrier],
  },
  'microdental rfp': {
    selectValues: '* EXCLUDE(CUSTOMER, CARRIER)',
    title: 'MicroDental RFP',
    db: 'SF',
    tableName: 'REPORT.RFP_BILLING_ACCOUNT_DESCRIPTION_VW',
    whereField: ["CUSTOMER", "CARRIER"],
    whereOperators: ['=', '='],
    orderBy: "CASE WHEN ACCOUNT_DESCRIPTION = 'TOTAL' THEN 1 ELSE 0 END, ACCOUNT_DESCRIPTION",
    getWhereValue: (params) => [Cookies.get('cp-cn'), params.carrier],
  },
  'delivery manifest': {
    selectValues: '*',
    title: 'Delivery Manifest',
    db: 'SF',
    tableName: 'REPORT.BIOVATION_DELIVERY_MANIFEST_VW',
    whereField: ["GTMS Task Name",],
    whereOperators: ['!=',],
    orderBy: '"Delivery Date" ASC',
    getWhereValue: () => ['Unknown'],
  },
  'truware shipment status report': {
    selectValues: 'ID, PO_NUMBER, STATUS, SOS_EXPECTED_DATE, SOS_EXPECTED_SHIP',
    title: 'Truwear Shipment Report',
    db: 'SF',
    tableName: 'REPORT.TRUEWARE_PO_LEVEL',
    whereField: ["STATUS",],
    whereOperators: ['!=',],
    orderBy: "STATUS DESC",
    getWhereValue: () => ['Unknown'],
  },
  'demo shipment status report': {
    selectValues: '*',
    title: 'demo Shipment Report',
    db: 'SF',
    tableName: 'REPORT.DEMO_PO_LEVEL',
    whereField: ["STATUS",],
    whereOperators: ['!=',],
    orderBy: "STATUS DESC",
    getWhereValue: () => ['Unknown'],
  },
  'truware sub level': {
    selectValues: 'ID, PARENT_ID , NAME ',
    title: 'Truwear Shipment Report',
    db: 'SF',
    tableName: 'REPORT.TRUEWARE_PO_SUB_LEVEL',
    whereField: ["PARENT_ID",],
    whereOperators: ['=',],
    orderBy: "NAME DESC",
    getWhereValue: (params) => [params.id],
  },
    'demo sub level': {
    selectValues: 'ID, PARENT_ID , NAME ',
    title: 'Demo Shipment Report',
    db: 'SF',
    tableName: 'REPORT.DOES_NOT_EXIST',
    whereField: ["PARENT_ID",],
    whereOperators: ['=',],
    orderBy: "NAME DESC",
    getWhereValue: (params) => [params.id],
  },
  'shipment status details': {
    selectValues: '*',
    title: 'Shipment Status Details',
    db: 'SF',
    tableName: 'REPORT.SHIPMENT_STATUS_DETAILS',
    whereField: ["ID",],
    whereOperators: ['=',],
    orderBy: "ID DESC",
    getWhereValue: (params) => [params.id],
  },
  'po management status': {
    selectValues: "STATUS_DATE, STATUS_DESCRIPTION",
    title: 'PO Management Status',
    db: 'SQL SERVER',
    tableName: 'REPORTS.PO_MANAGEMENT_TMS_STATUSES_VW',
    whereField: ['LOAD_NAME'],
    whereOperators: ['='],
    orderBy: 'STATUS_DATE DESC',
    getWhereValue: (params) => [params.name],
  },
  'ocean tracking availability': {
    selectValues: 'COUNT(*) AS RECORD_COUNT',
    title: 'ocean tracking availability',
    db: 'SF',
    tableName: 'REPORT.OCEAN_TRACKING_HEADER',
    whereField: ["PO_NUMBER",],
    whereOperators: ['=',],
    orderBy: "PO_NUMBER DESC",
    getWhereValue: (params) => [params.name],
  },
  'biov po management header': {
    selectValues: 'ID, NAME, PURCHASE_ORDER, BOL_NUMBER, CARRIER, PRO_NUMBER, STATUS',
    title: 'biov po management header',
    db: 'SF',
    tableName: 'REPORT.BIOVATION_PO_MANAGEMENT_HEADER_VW',
    whereField: ["ID",],
    whereOperators: ['!=',],
    orderBy: "STATUS DESC",
    getWhereValue: () => ['Unknown'],
  },
  'dock appointment': {
    selectValues: 'ID, NAME, CARRIER, DELIVERY_DATE, DELIVERY_TIME, PALLETS, ITEM, STATUS',
    title: 'dock appointment',
    db: 'SF',
    tableName: 'REPORT.DOCK_APPOINTMENT_VW',
    whereField: ["ID",],
    whereOperators: ['!=',],
    orderBy: "DELIVERY_DATE DESC",
    getWhereValue: () => ['Unknown'],
  },
  'report info': {
    selectValues: 'TIME_RANGE, REPORT_DESCRIPTION',
    title: 'report info',
    db: 'SQL SERVER',
    tableName: 'REPORTS.REPORT_INFO',
    whereField: ['FK_REPORT_ID'],
    whereOperators: ['='],
    orderBy: 'TIME_RANGE DESC',
    getWhereValue: (params) => [params.id], 
  }
};
